import React from 'react';
import { Box, Typography } from '@mui/material';
import noChatFoundImage from '../../../../../assets/images/NoChatFound.png';
import ChatBackIcon from '../../../../../assets/svg-fc/ChatBackIcon';
import IsMobile from '../../../../../hooks/isMobile';
import './emptyChatComponent.scss';

interface EmptyChatComponentProps {
  emptyChatHeading?: string | null;
  onBackClick?: () => void;
}

const EmptyChatComponent: React.FC<EmptyChatComponentProps> = ({ onBackClick, emptyChatHeading }) => {
  const isMobile = IsMobile();

  return (
    <Box className="emptyChatComponent">
      {isMobile && onBackClick && (
        <Box className="emptyChatBackIcon" onClick={onBackClick}>
          <ChatBackIcon size="18" />
        </Box>
      )}
      <img className="EmptyChatComponentImage" src={noChatFoundImage} alt="No data" />
      <Typography className="noChatFoundText__heading" variant="h6">
        {emptyChatHeading || 'Start Chatting'}
      </Typography>
      <Typography className="noChatFoundText__description" variant="body1">
        Your chat will appear here
      </Typography>
    </Box>
  );
};

export default EmptyChatComponent;
